import mitt from 'mitt'

export const emitter = mitt<{
  toast: ToastEvent
  alert: AlertEvent
  loading: undefined
  closeLoading: undefined
  logout: LogoutEvent
  checkPlayer: CheckPlayerEvent
  checkPlayerReturn: boolean
  webLoginLoad: void
}>()
